module.exports = "<h2 id=\"about-us\">ABOUT US</h2>\n<p>Our wish is an atmosphere that makes it easy\nfor you to see the Nice, to taste the Fine\nand simply be comfortable.\nWith a pure, finely nuanced kitchen,\nwhich focuses on the obvious and good taste.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/about_en.md
// module id = M8yz
// module chunks = 0